import IconWrapper, { IconWrapperProps } from '@repo/ui/src/components/IconWrapper';

interface CartIconProps extends IconWrapperProps {
  color?: string;
}

const CartIcon = ({ color = 'currentColor', ...rest }: CartIconProps) => (
  <IconWrapper viewBox="0 0 24 24" title="Shopping Cart" {...rest}>
    <path
      fill={color}
      fillRule="evenodd"
      d="M22.997 20.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001Zm-13 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM8.017 12l-1.2-6h14.737l-2.25 6H8.017Zm12.917 1.352 3-8.001A1 1 0 0 0 22.997 4H6.417l-.44-2.196c-.006-.035-.028-.061-.039-.094a.98.98 0 0 0-.47-.577.987.987 0 0 0-.368-.112C5.064 1.017 5.034 1 4.997 1h-4a1 1 0 0 0 0 2h3.18l2.84 14.196a1 1 0 0 0 .98.804h14a1 1 0 1 0 0-2H8.817l-.4-2h11.58c.417 0 .79-.259.937-.648Z"
      clipRule="evenodd"
    />
  </IconWrapper>
);

export default CartIcon;
